var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavoriteInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1718_3529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8787 7.11062C24.1715 4.4063 19.8323 4.30068 17.0001 6.79416C14.1683 4.30081 9.82906 4.4063 7.1216 7.11062C5.7488 8.48196 5 10.2944 5 12.2221C5 14.1498 5.7488 15.9621 7.1216 17.3239L16.664 26.8562C16.7504 26.9425 16.8752 27 17 27C17.1248 27 17.2496 26.9521 17.336 26.8562L26.8784 17.3239C28.2416 15.9621 29 14.1498 29 12.2221C29 10.2944 28.2512 8.48209 26.8784 7.11062H26.8787ZM26.2067 16.6523L17.0004 25.8394L7.79411 16.6429C6.61331 15.4633 5.96051 13.8907 5.96051 12.2219C5.96051 10.553 6.61331 8.9805 7.79411 7.79137C9.01331 6.57346 10.6165 5.95972 12.2293 5.95972C13.8325 5.95972 15.4357 6.57346 16.6645 7.79137C16.8565 7.98316 17.1541 7.98316 17.3461 7.79137C19.7941 5.34597 23.7686 5.34597 26.2068 7.79137C27.3876 8.97091 28.0404 10.5435 28.0404 12.2219C28.0404 13.8905 27.3876 15.4632 26.2068 16.6523H26.2067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9493 7.03987C24.2255 4.31899 19.8726 4.19278 17.0001 6.66162C14.1279 4.1929 9.77496 4.31899 7.05093 7.03987L7.05093 7.03987C5.65935 8.42997 4.9 10.2679 4.9 12.2221C4.9 14.1762 5.65925 16.0141 7.05097 17.3947C7.05104 17.3948 7.05111 17.3948 7.05118 17.3949L16.5933 26.9269C16.6964 27.0299 16.8459 27.1 17 27.1C17.1486 27.1 17.3009 27.0433 17.4085 26.9251L26.9491 17.3946C28.3309 16.0143 29.1 14.1766 29.1 12.2221C29.1 10.3469 28.4008 8.57885 27.1147 7.21062H27.1203L26.9493 7.03987ZM27.9404 12.2219C27.9404 13.8586 27.3023 15.4014 26.147 16.5706L26.136 16.5816L17.0004 25.6981L7.86478 16.5721C6.70273 15.4113 6.06051 13.8642 6.06051 12.2219C6.06051 10.5797 6.70264 9.03255 7.86492 7.86199C9.06458 6.66367 10.642 6.05972 12.2293 6.05972C13.8069 6.05972 15.3845 6.66358 16.594 7.86226C16.825 8.09292 17.1858 8.09287 17.4168 7.86212C19.8258 5.45564 23.737 5.45585 26.136 7.86197L26.1361 7.86212C27.2981 9.02288 27.9404 10.57 27.9404 12.2219Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1718_3529",
    x: 0.800049,
    y: 0.799988,
    width: 32.3999,
    height: 30.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1718_3529"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1718_3529",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteInactive);
export default __webpack_public_path__ + "static/media/favorite_inactive.2eac3f93fcae389e38c831f096daab83.svg";
export { ForwardRef as ReactComponent };